export class ParseContract {
    constructor(contractABI, contractAddress, connex) {
        this.contractABI = contractABI;
        this.contractAddress = contractAddress;
        this.connex = connex;
    }

    getMethod(method) {
        const methodAbi = Object.values(this.contractABI).find(value => value.name === method);
        return this.connex.thor.account(this.contractAddress).method(methodAbi);
    }

    getEvent(event) {
        const eventAbi = Object.values(this.contractABI).find(value => value.name === event);
        return this.connex.thor.account(this.contractAddress).event(eventAbi);
    }
}


